import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { PublicCatalogProvider, readPageSnapshot } from "./contexts/PublicCatalogContext";
import { App } from "./App";
import "./styles/index.css";

const snapshot = readPageSnapshot();
const root = document.getElementById("root")!;
const application = (
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <PublicCatalogProvider catalog={snapshot}>
          <App />
        </PublicCatalogProvider>
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>
);

if (snapshot?.path === window.location.pathname && !window.location.search) {
  ReactDOM.hydrateRoot(root, application);
} else {
  ReactDOM.createRoot(root).render(application);
}
